module.exports = __webpack_public_path__ + "static/media/grin-beam-sweat.5dfc294e.svg";